import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Routable::JoinUser @model={{this.model}} />",{ moduleName: "mewe/templates/invite.hbs" })